const externalLoginType = Object.freeze({
  Microsoft: 'Microsoft',
  Google: 'Google',
  Duo: 'Duo',
});

export default externalLoginType;
